module.exports = __webpack_public_path__ + "static/media/dz.1f8308ea.svg";